/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

 $(document).ready(function(e){
    console.log("Custom loaded");

    $(document).on('click',".Drawer__Footer .Cart__Checkout",function(e){
        e.preventDefault();
        if($("[data-is-recurring]").length > 0) {
            var paramCart = '&cart_token=' + (document.cookie.match('(^|; )cart=([^;]*)')||0)[2];
            
            try {
                var paramLinker = "&" + ga.getAll()[0].get('linkerParam');
            } catch (err) {
                var paramLinker = '';
            }
            
            window.location = "https://checkout.rechargeapps.com/r/checkout?" + paramDomain +  paramCart + paramLinker + paramCustomer;

        } else {
            window.location = "/checkout";
        }
    });

    if($("#shopify-section-product-template").length > 0) {
        //Making sure it's Product page

        var allowed_variant = $("[data-rc-tags]").attr('data-rc-tags').replace("sub_var_title_","");
        if($("[data-variant-select] option:selected").text().indexOf(allowed_variant) == -1) {
            $("div#rc_container").fadeOut(0);
        } else {
            $("div#rc_container").fadeIn(100);
        }

        $(document).on('change','.rc_radio',function(e){
            if($("input.rc_radio:checked").val() == "autodeliver"){
                var otp = $("#rc_price_onetime").text();
                var subp = $("#rc_price_autodeliver").text();
                $(".Price--highlight").text(subp);
                $(".Price--compareAt").text(otp);
                $('.ProductMeta__Sku').html(sub_and_save_text);
            } else {
                var otp = $("[data-variant-select] option:selected").attr("data-price");
                var subp = $("[data-variant-select] option:selected").attr("data-compareat");
                $(".Price--highlight").text(otp);
                $(".Price--compareAt").text(subp);
                $('.ProductMeta__Sku').html(non_sub_text);
                
            }
        });

        $(".ProductForm__Variants").on('DOMSubtreeModified', function(){
            window.setTimeout(function(){
                console.log($("[data-variant-select] option:selected").text());
                $("[data-variant-select]").trigger('click');
                if($("[data-variant-select] option:selected").text().indexOf(allowed_variant) == -1) {
                    $("div#rc_container").attr('style','display:none !important;');
                    $("div#rc_container").fadeOut(0);
                    jQuery(".rc_radio__onetime").attr('checked');
                    jQuery(".rc_radio__onetime").trigger('change');
                    jQuery(".rc_radio__onetime").trigger('click');
                } else {
                    $("div#rc_container").removeAttr('style');
                    $("div#rc_container").fadeIn(100);                    
                } 
            },50);
                       
        }); 
    }
 });